import { useAppSelector } from '@Hooks/ReduxHooks'
import React from 'react'
import styled from 'styled-components'
import CustomLanding from '../CustomLanding'
import StudentLanding from '../StudentLanding'
import PromoCountdown from '../CustomLanding/Components/PromoCountdown'

/* tenant/mribrahimfarid: guests get the bespoke instructor landing page
   instead of GuestLanding; logged-in students keep StudentLanding.

   PromoCountdown sits above the fork so both audiences see it from one mount
   and StudentLanding stays untouched. It is TEMPORARY (Sept 2026 campaign) and
   hides itself outside its window — revert its commit to remove it. */
const LandingPage = () => {
	const { isAuth } = useAppSelector(state => state.auth)

	return (
		<Stack>
			<PromoCountdown />
			{isAuth ? <StudentLanding /> : <CustomLanding />}
		</Stack>
	)
}

export default LandingPage

/* Layout's StyledLayoutContent is `display: flex` with the default ROW
   direction, and this page used to hand it exactly one child. Returning a
   fragment with two children made them flex SIBLINGS, so the banner rendered
   as a full-height column beside the page (on the right, in RTL).

   This keeps LandingPage a single flex item — `flex: 1` so it still fills the
   row as the lone child did — and stacks the banner above the landing inside
   it. min-width: 0 because a flex item defaults to min-width:auto and would
   otherwise refuse to shrink below its content. */
const Stack = styled.div`
	flex: 1;
	min-width: 0;
	display: flex;
	flex-direction: column;
`
